import React from "react";
import { getString } from "../../utilities";
import lockIcon from "../../../assets/img/unlockColor.svg";
import devicesIcon from "../../../assets/img/devices.svg";

export default function PlanPerks({ devices }) {
  return (
    <ul className="subscribe-plans-perks">
      <li>
        <img src={lockIcon} width="72.3" height="64.07" className="icon" loading="lazy" alt="" />
        {getString("subscribe.plans.perks.access")}
      </li>
      <li>
        <img src={devicesIcon} width="81.32" height="60.19" className="icon" loading="lazy" alt="" />
        {devices}
      </li>
    </ul>
  );
}
